<h2>Providers</h2>
<div class="mat-elevation-z8">
  <div class="table-responsive text-center justify-content-center" style="
      font-size: 14px;
      margin-bottom: 20px;
      text-align: center;
      vertical-align: center;
    ">
    <p-table #dt1 dataKey="id" [value]="providers" [rows]="10" [paginator]="true" [showCurrentPageReport]="true"
      [scrollable]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['name', 'email', 'contact_name', 'phone_number']">
      <ng-template pTemplate="caption">
        <div class="table-header float-right">
          <div class="ui-table-globalfilter-container">
            <input type="text" pInputText size="50" placeholder="Search"
              (input)="dt1.filterGlobal($event.target.value, 'contains')" style="width: 250px; margin-left: 75%" />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <!-- <th *ngFor="let col of displayedColumns" pSortableColumn="{{ col }}">
            <b>{{ col | titlecase }}</b>
            <p-sortIcon [field]="col"></p-sortIcon>
          </th> -->
          <th pSortableColumn="name" style="width: auto;">
            <b>Name</b><p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pSortableColumn="email" style="width: 25%;">
            <b>Email</b><p-sortIcon field="email"></p-sortIcon>
          </th>
          <th pSortableColumn="approve" style="width: auto;">
            <b>Approve</b><p-sortIcon field="approve"></p-sortIcon>
          </th>
          <th pSortableColumn="contact_name" style="width: auto;">
            <b>Contact Name</b><p-sortIcon field="contact_name"></p-sortIcon>
          </th>
          <th pSortableColumn="phone_number" style="width: auto;">
            <b>Phone Number</b><p-sortIcon field="phone_number"></p-sortIcon>
          </th>
          <th pSortableColumn="created_at" style="width: auto;">
            <b>Created Date</b><p-sortIcon field="created_at"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-provider>
        <tr>
          <td style="width: auto;">{{ provider.name }}</td>
          <td style="width: 25%;overflow-x: auto;">{{ provider.email }}</td>

          <td style="width: auto;">
            <div *ngIf="provider.is_verified">Approved</div>
            <div *ngIf="!provider.is_verified">
              <p-button label="Approve" (click)="updateProviderStatus(provider.id, true)"></p-button>
            </div>
          </td>
          <td style="width: auto;">
            {{ provider.contact_name }}
          </td>
          <td style="width: auto;">{{ provider.phone_number }}</td>
          <td style="width: auto;">
            {{ provider.created_at | date }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="ui-g-12">
    <app-error-messages [api_result]="this.approveprovider.create_api_result">
    </app-error-messages>
  </div>
</div>